// @flow

import adaptGrouping from './adapt-grouping';
import getSizeVariants from '../../../size-variants';
import getAppliedValues from './get-applied-values';
import flattenSize from '../../../size-facet-helper';

const FACET_IDENTIFIER = 'id';

export const adaptOption = (
  style: AdaptedFacetStyle,
  variant: AdaptedFacetVariant,
  dimension: AdaptedFacetDimension,
  option: FacetOption,
  index: number,
  identifier: string
): OldFacetOption => {
  const id = option[identifier].toString();
  // $FlowFixMe
  const applied = option.applied?.toString();
  const attributeMap: OptionAttributeMap = {
    dimensionId: dimension[identifier].toString(),
    index: index.toString(),
    variantId: variant[identifier].toString(),
  };
  const [sizeOptionId, sizeOptionName] = option.name.split(':');

  if (!!sizeOptionName) {
    attributeMap.searchFacetOptionName2 = sizeOptionName.toString();
  }

  return {
    searchFacetOptionId:
      identifier === 'name'
        ? `${variant.name}|${style.name}|${dimension.name}|${id}`
        : id,
    searchFacetOptionName: sizeOptionId.toString(),
    searchFacetOptionValue: id,
    isActive: 'true',
    isSelected: applied,
    attributeMap,
  };
};

export const adaptVariant = (
  style: AdaptedFacetStyle,
  variant: AdaptedFacetVariant,
  dimension: AdaptedFacetDimension,
  identifier: string
): OldFacetVariant => {
  return {
    searchFacetOptionList: variant.options.map((option, index) =>
      adaptOption(style, variant, dimension, option, index, identifier)
    ),
    parentSearchFacetOptionGroupId: dimension[identifier].toString(),
    searchFacetOptionGroupId: variant[identifier].toString(),
    searchFacetOptionGroupName: variant.name.toString(),
  };
};

export const adaptDimension = (
  style: AdaptedFacetStyle,
  dimension: AdaptedFacetDimension,
  identifier: string
): OldFacetDimension => {
  return {
    searchFacetOptionGroupList: dimension.options.map((variant) =>
      adaptVariant(style, variant, dimension, identifier)
    ),
    parentSearchFacetOptionGroupId: style[identifier].toString(),
    searchFacetOptionGroupId: dimension[identifier].toString(),
    searchFacetOptionGroupName: dimension.name.toString(),
  };
};

export const adaptStyle = (
  style: AdaptedFacetStyle,
  identifier: string
): OldFacetStyle => {
  const dimensions = style.options.map((dimension) =>
    adaptDimension(style, dimension, identifier)
  );

  return {
    searchFacetOptionGroupList:
      dimensions.length === 1 ? dimensions.shift() : dimensions,
    searchFacetOptionGroupId: style[identifier].toString(),
    searchFacetOptionGroupName: style.name.toString(),
  };
};

export const adaptSize = (
  facet: SizeFacetWithConfig
): { facet: OldFacet, appliedValues: Array<any> } => {
  const size = {
    isActive: 'true',
    order: facet.order,
    type: facet.type,
    name: facet.name.toString(),
    searchFacetId: facet.name.toString(),
    displayName: facet.displayName.toString(),
    selectionType: facet.selectionType.toString(),
    searchFacetName: facet.displayName.toString(),
    searchFacetOptionGroupList: adaptGrouping(
      facet.options,
      FACET_IDENTIFIER
    ).map((x) => adaptStyle(x, FACET_IDENTIFIER)),
  };

  const flattenedSize = flattenSize(size);

  return {
    facet: {
      ...size,
      sizeVariants: getSizeVariants(flattenedSize),
    },
    appliedValues: getAppliedValues(flattenedSize),
  };
};
